import { render, staticRenderFns } from "./details_center.vue?vue&type=template&id=ef46fde4&scoped=true&"
import script from "./details_center.vue?vue&type=script&lang=js&"
export * from "./details_center.vue?vue&type=script&lang=js&"
import style0 from "./details_center.vue?vue&type=style&index=0&id=ef46fde4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef46fde4",
  null
  
)

export default component.exports